import versionInfo from '../../../version.json';
import { Environment } from './environment.interface';

export const environment: Environment = {
  production: true,

  version: versionInfo.version,

  serverUrl: 'https://api.stageflux.com',

  helpDomain: 'knowledge-base.stageflux.com',

  logging: {
    enabled: true,

    dsn: 'https://b9f6508dd2643dbf29d3e0ffe0929018@o4508320251445248.ingest.us.sentry.io/4508320333955072',
  },

  tracking: {
    enabled: true,

    stageFlux: {
      siteId: '0196f2ef-ffdd-7763-863e-4f72d60caf46',
    },
  },

  links: {
    landingSiteUrl: 'https://www.stageflux.com',
    helpSiteUrl: 'https://help.stageflux.com',
    developerSiteUrl: 'https://help.stageflux.com/developers',
    supportEmail: 'support@stageflux.com',
    termsAndConditionsUrl: 'https://www.stageflux.com/terms',
    privacyPolicyUrl: 'https://www.stageflux.com/privacy',
    visitorScriptUrl: 'https://visitor.stageflux.com',
  },
};
